// src/components/CentralLoader.js
import { Backdrop, CircularProgress } from "@mui/material";
import { useLoading } from "../../context";

const BTLoader = () => {
  const { loading } = useLoading();

  return (
    <Backdrop
      sx={{
        color: "#fff",
        zIndex: (theme) => theme.zIndex.drawer + 1,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
      }}
      open={loading}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  );
};

export default BTLoader;
